import { Component, EventEmitter, OnInit, Output } from '@angular/core';

import { AppSettingsService } from '~/core/services/appsettings.service';
import { AppSettings } from '~/core/models/appsettings';

@Component({
	selector: 'footer',
	templateUrl: './footer.component.html',
	styleUrls: ['./footer.component.scss'],
	standalone: false
})

export class FooterComponent implements OnInit {
	@Output() setLayoutCssClass = new EventEmitter();

	public date = new Date();
	public version: any = "0.0.0";

	constructor(private appSettingsService: AppSettingsService) { }

	//*************************************************************************
	//  Component Life-Cycle Methods
	//*************************************************************************
	public async ngOnInit() {
		let settings: AppSettings = await this.appSettingsService.getSettings();

		this.version = settings.version;
	}
}
